import React, { useState } from "react";
import { Gallery } from "react-grid-gallery";

const images = [
  {
    src: "https://kippra.or.ke/wp-content/uploads/2023/10/KIPPRA-Executive-Director-Dr-Rose-Ngugi-giving-her-remarks-at-the-6th-KIPPRA-Annual-Regional-Conference-scaled.jpg",
    thumbnail: "https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_n.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    isSelected: false,
    caption: "After Rain (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2023/10/The-KIPPRA-Board-Chair-Dr.-Atenggiving-his-opening-remarks-during-the-5th-KIPPRA-Annual-Regional-Conference-scaled.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2023/10/DSC_9241-scaled.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2023/10/DSC_9241-scaled.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
  {
    src: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnail: "https://kippra.or.ke/wp-content/uploads/2022/06/DSC08348-1024x577.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 212,
    tags: [
      { value: "Ocean", title: "Ocean" },
      { value: "People", title: "People" },
    ],
    caption: "Boats (Jeshu John - designerspics.com)",
  },
];

const MyGallery = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (index) => {
    setSelectedImage(index);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalIsOpen(false);
  };

  const selectedImg = selectedImage !== null && images[selectedImage];

  return (
    <>
      <Gallery images={images} onClickThumbnail={openModal} 
      grid={{xs:1, sm:2, md:3, lg:4, xl:5, xxl:6}}
      
      />

      {modalIsOpen && (
        <div className="modal-container">
          <div className="modal">
            <img src={selectedImg.src} alt={selectedImg.caption} />
            <button className="close-btn" onClick={closeModal}>
              X
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .modal-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .modal {
          position: relative;
        }
        .modal img {
          max-width: 100%;
          max-height: 100%;
        }
        .close-btn {
          position: absolute;
          top: 0;
          right: 0;
          padding: 10px;
          font-size: 24px;
          font-weight: bold;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.6);
          border: none;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default  MyGallery;
 